import React, { useCallback, useMemo, useState } from "react";
import {
  TeamOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  CalendarOutlined,
  DashboardOutlined,
  RobotOutlined,
  BorderInnerOutlined,
  StopOutlined,
  ShoppingOutlined,
  FieldTimeOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Layout,
  Menu,
  theme,
  Grid,
  Button,
  Avatar,
  Dropdown,
  Space,
  Drawer,
} from "antd";
import { useLocation, useNavigate, Link, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const { Header, Content, Sider } = Layout;
const { useBreakpoint } = Grid;

const Panel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const { user, logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleLogout = useCallback(() => {
    localStorage.removeItem("user");
    logout();
    navigate("/admin/login", { replace: true });
  }, [logout, navigate]);

  const menuItems = [
    {
      key: "publicImages",
      icon: <PictureOutlined />,
      label: <Link to="catalogo">Catálogo</Link>,
    },
    {
      key: "sub1",
      icon: <DashboardOutlined />,
      label: <Link to="/admin">Dashboard</Link>,
    },
    {
      key: "sub2",
      icon: <CalendarOutlined />,
      label: <Link to="/admin/agenda">Reservaciones</Link>,
    },
    {
      key: "sub3",
      icon: <UserOutlined />,
      label: <Link to="usuarios">Usuarios</Link>,
    },
    {
      key: "sub4",
      icon: <BorderInnerOutlined />,
      label: <Link to="servicios">Servicios</Link>,
    },
    {
      key: "sub5",
      icon: <TeamOutlined />,
      label: <Link to="empleados">Empleados</Link>,
    },
    {
      key: "sub8",
      icon: <ShoppingOutlined />,
      label: <Link to="productos">Productos</Link>,
    },
    {
      key: "sub9",
      icon: <FieldTimeOutlined />,
      label: <Link to="asistencia">Asistencia</Link>,
    },
    {
      key: "sub6",
      icon: <RobotOutlined />,
      label: <Link to="qr">WhatsApp</Link>,
    },
    {
      key: "sub7",
      icon: <StopOutlined />,
      label: <Link to="crear-horario">Bloqueos</Link>,
    },
  ];

  const avatarMenu = useMemo(
    () => ({
      items: [
        {
          key: "logout",
          label: "Cerrar sesión",
          onClick: handleLogout,
        },
      ],
    }),
    [handleLogout]
  );

  const selectedMenuKey = useMemo(() => {
    if (location.pathname.startsWith("/admin/imagenes-publicas")) return ["publicImages"];
    if (location.pathname.startsWith("/admin/catalogo")) return ["publicImages"];
    if (location.pathname.startsWith("/admin/reservas")) return ["sub2"];
    if (location.pathname.startsWith("/admin/agenda")) return ["sub2"];
    if (location.pathname.startsWith("/admin/usuarios")) return ["sub3"];
    if (location.pathname.startsWith("/admin/servicios")) return ["sub4"];
    if (location.pathname.startsWith("/admin/empleados")) return ["sub5"];
    if (location.pathname.startsWith("/admin/productos")) return ["sub8"];
    if (location.pathname.startsWith("/admin/ventas-productos")) return ["sub8"];
    if (location.pathname.startsWith("/admin/asistencia")) return ["sub9"];
    if (location.pathname.startsWith("/admin/qr")) return ["sub6"];
    if (location.pathname.startsWith("/admin/crear-horario")) return ["sub7"];
    return ["sub1"];
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 16px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          {!screens.md && (
            <Button
              type="text"
              icon={<MenuUnfoldOutlined />}
              onClick={() => setDrawerVisible(true)}
              style={{ color: "#fff", marginRight: 16 }}
            />
          )}
        </div>

        <Dropdown menu={avatarMenu} placement="bottomRight" arrow>
          <Space style={{ color: "#fff", cursor: "pointer", fontWeight: 500 }}>
            Hola, {user?.name || "Admin"}
            <Avatar
              size="large"
              style={{
                backgroundColor: user?.background_avatar || "#ffffff",
                color: user?.background_avatar ? "#fff" : "#111",
                fontWeight: "bold",
                fontSize: 22,
              }}
            >
              {user?.name ? user.name.charAt(0).toUpperCase() : "A"}
            </Avatar>
          </Space>
        </Dropdown>
      </Header>

      <Layout>
        {screens.md ? (
          <Sider
            width={220}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            style={{ background: colorBgContainer }}
          >
            <Menu
              mode="inline"
              selectedKeys={selectedMenuKey}
              style={{ height: "100%", borderRight: 0 }}
              items={menuItems}
            />
          </Sider>
        ) : (
          <Drawer
            title="Menú"
            placement="left"
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
            styles={{ body: { padding: 0 } }}
          >
            <Menu
              mode="inline"
              selectedKeys={selectedMenuKey}
              style={{ height: "100%" }}
              items={menuItems}
              onClick={() => setDrawerVisible(false)}
            />
          </Drawer>
        )}

        <Layout style={{ minWidth: 0, padding: screens.md ? "0 24px 24px" : 0 }}>
          <Breadcrumb items={[{ title: "" }]} style={{ margin: screens.md ? "16px 0" : 0 }} />
          <Content
            style={{
              padding: screens.md ? 24 : 0,
              margin: 0,
              minWidth: 0,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Panel;
